import  { isProduction } from '../config/constants'
import UuidV4 from 'uuid/v4'

export function getTimeStamp() {
  return new Date().getTime();
}

export function getUUIDV4() {
  return UuidV4();
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js